<template>
  <keyboard-base-ingenico
    v-if="IS_INGENICO"
    :use-listener="useListener"
    :from-home="fromHome"
    :w2s-disabled="w2sDisabled"
    :scan-disabled="scanDisabled"
    :contact-disabled="contactDisabled"
    @add="add"
    @del="del"
    @cancel="cancel"
    @valid="$emit('valid')"
    @func="$emit('func')"
    @menu="$emit('menu')"
    @carrier="$emit('carrier')"
    @w2s="$emit('w2s')"
    @badge="$emit('badge')"
    @scan="$emit('scan')"
    @menu-longpress="menuLongPress"
  />
  <keyboard-base
    v-else
    :use-listener="useListener"
    :from-home="fromHome"
    :w2s-disabled="w2sDisabled"
    :scan-disabled="scanDisabled"
    :contact-disabled="contactDisabled"
    @add="add"
    @del="del"
    @cancel="cancel"
    @valid="$emit('valid')"
    @func="$emit('func')"
    @menu="$emit('menu')"
    @carrier="$emit('carrier')"
    @w2s="$emit('w2s')"
    @badge="$emit('badge')"
    @scan="$emit('scan')"
    @menu-longpress="menuLongPress"
  />
</template>

<script>
import KeyboardBase from './KeyboardBase'
import KeyboardBaseIngenico from './KeyboardBaseIngenico'

export default {
  name: 'Keyboard',

  components: {
    KeyboardBase,
    KeyboardBaseIngenico
  },

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: { type: Number, default: 0 },
    max: { type: Number, default: null },
    useListener: { type: Boolean, default: true },
    fromHome: { type: Boolean, default: false },
    contactDisabled: { type: Boolean, default: false },
    w2sDisabled: { type: Boolean, default: false },
    scanDisabled: { type: Boolean, default: false }
  },

  data() {
    return {
      IS_INGENICO
    }
  },

  methods: {
    // ********** KEYBOARD **********
    add (number, double = false) {
      // On ajoute un chiffre.
      let newValue = (this.value * (double ? 100 : 10)) + number

      // limite à 7 chiffres
      if (newValue < 10000000 && (this.max === null || newValue <= this.max)) {
        this.$emit('input', newValue)
      }
    },
    del () {
      if (this.value === 0) {
        this.$emit('del')
      } else {
        // On supprime le dernier chiffre.
        let newValue = Math.trunc(this.value / 10)
        this.$emit('input',  newValue)
      }
    },
    cancel () {
      if (this.value === 0) {
        this.$emit('cancel')
      } else {
        this.$emit('input',  0)
      }
    },
    menuLongPress () {
      this.$emit('menu-longpress')
    }
  }
}
</script>
